module.exports = __webpack_public_path__ + "media/images/brand/amex-4a86b5927dd16275c569850d3b13abf3.png";